"use client";
import { getHotelLoading } from "@/lib/features/hotel/hotelSlice";
import { useAppSelector } from "@/lib/hooks";
import { useParams, useSearchParams } from "next/navigation";
import React, { useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HotelFacilities = ({ hotel, loading }: { hotel: any; loading: boolean }) => {
  const maxLength = 24;
  const amenities: string[] =
    hotel != "undefined" &&  hotel?.facilities && 
    hotel?.facilities
      .split(" ; ")
      .map((item: string) => item.trim())
      .sort((a: string, b: string) => a.localeCompare(b));

  const [showAll, setShowAll] = useState(false);
  const visibleAmenities = showAll ? amenities : amenities?.slice(0, maxLength);

  const toggleShowAll = () => setShowAll(!showAll);

  const uiClass = amenities?.length > 35 ? "col-6 col-lg-2" : "col-6 col-lg-4";
  return (
    <>
      {loading ? (
        // Skeleton loader for loading state
        <>
          {[...Array(maxLength)].map((_, index) => (
            <div className={uiClass} key={index}>
              <Skeleton height={20} width={amenities?.length > 35 ? 150: 250} />
            </div>
          ))}
        </>
      ) : (
        visibleAmenities?.length > 0 ? (
          visibleAmenities?.map((amenity: string, index: number) => (
            <div className={uiClass} key={index}>
              <div className="d-flex x-gap-15 y-gap-15 items-center">
                {/* <i className="icon-no-smoke"></i> */}
                <div className="text-15">{amenity}</div>
              </div>
            </div>
          ))
        ) : (
          <div className={uiClass}>
            <div className="d-flex x-gap-15 y-gap-15 items-center">
              {/* <i className="icon-no-smoke"></i> */}
              <div className="text-15">No amenities available</div>
            </div>
          </div>
        )
      )}
       

      {!loading && amenities?.length > maxLength && (
        <button
          onClick={toggleShowAll}
          className="d-block text-14 text-blue-1 fw-500 underline mt-10"
        >
          {showAll ? "Show Less" : "Show More"}
        </button>
      )}
    </>
  );
};

export default HotelFacilities;
